import { getPublicMembershipOffer } from "@outschool/business-rules";

import { MEMBERSHIP_20_OFF_FIRST_MONTH_FEATURE_FLAG } from "../../shared/featureFlags";
import { useFeatureFlag } from "../lib/FeatureFlags";

export function usePublicMembershipOffer() {
  const isTwentyDollarOfferEnabled = useFeatureFlag(
    MEMBERSHIP_20_OFF_FIRST_MONTH_FEATURE_FLAG,
  );

  return {
    ...getPublicMembershipOffer(isTwentyDollarOfferEnabled),
    isTwentyDollarOfferEnabled,
  };
}
